import React from 'react';
import { Box, Typography } from '@mui/joy';
import AdminBatchAttendance from '../../components/congregation/AdminBatchAttendance';

export default function CongregationAttendancePage() {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        p: { xs: 2, md: 3 },
      }}
    >
      <AdminBatchAttendance />
    </Box>
  );
}
